import { render, staticRenderFns } from "./cookiePolicy.vue?vue&type=template&id=02e24b50"
import script from "./cookiePolicy.vue?vue&type=script&lang=js"
export * from "./cookiePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports